import React from 'react';
import './Workflow.css';

const Workflow = () => {
  return (
    <section id="workflow" className="workflow-section">
      <div className="container">
        <div className="section-header-new">
          <h2>Perfect Workflow for Your Business</h2>
          <p>AI-powered solutions that work seamlessly with your existing processes</p>
        </div>
        <div className="workflow-grid">
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-clock"></i>
            </div>
            <h3>24/7 Availability</h3>
            <p>Never miss a customer interaction, day or night</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-calendar-check"></i>
            </div>
            <h3>Seamless Appointment Booking</h3>
            <p>Automated scheduling that syncs with your calendar</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-calculator"></i>
            </div>
            <h3>Automated Pricing Estimates</h3>
            <p>Instant quotes and pricing information for customers</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3>Lower Costs & Higher Efficiency</h3>
            <p>Reduce operational costs while improving service quality</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-headset"></i>
            </div>
            <h3>Instant Customer Assistance</h3>
            <p>Immediate responses to customer questions and concerns</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-users"></i>
            </div>
            <h3>Lead Nurturing & Follow Ups</h3>
            <p>Automated follow-up sequences to convert leads</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-star"></i>
            </div>
            <h3>Consistent Service Quality</h3>
            <p>Every customer gets the same high-quality experience</p>
          </div>
          <div className="workflow-item">
            <div className="workflow-icon">
              <i className="fas fa-robot"></i>
            </div>
            <h3>Fully Automated Workflow</h3>
            <p>Complete automation from first contact to conversion</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Workflow;
